{{#unless noData}}
    {{#unless notVisibleItem}}
        <div class="col-7">
            <a href="#" data-value="{{id}}" class="single-selection saved-view-item" title="{{#if isChanged}}{{defaultName}}{{else}}{{name}}{{/if}}"><span>{{#if isChanged}}{{defaultName}}{{else}}{{name}}{{/if}}</span></a>
        </div>
        {{#if isDefault}}
            <div class="col-4">
                <span class="grid-saved-views-default-value">{{locale "default"}}</span>
            </div>
        {{else}}
            <div class="col-4">
                <button type="button" class="btn btn-tertiary grid-save-view-make-default">{{locale "makeDefault"}}</button>
            </div>
        {{/if}}
        <div class="col-1">
            <button type="button" class="btn btn-tertiary grid-saved-views-remove">{{icon name="circle-close-solid" text="Remove saved views"}}</button>
        </div>
    {{/unless}}
{{/unless}}



